export default __webpack_public_path__ + "static/media/regulatory--dual-lanes-turn-right-or-straight--g1.bb64e50c.png";